// Fetches the per-module attachment caps for the Notes/Tasks uploaders.
// Cached briefly so opening many notes/tasks doesn't spam the endpoint.
import { notesApi } from '@/lib/notesApi';

let _cache = null;
let _at = 0;

export async function getNotesModuleCaps() {
  const now = Date.now();
  if (_cache && now - _at < 60000) return _cache;
  const { data } = await notesApi.get('/notes/attachment-caps');
  _cache = data || {};
  _at = now;
  return _cache;
}

// Invalidate the cache (e.g. after a settings change elsewhere in the app).
export function clearNotesCapsCache() { _cache = null; _at = 0; }
